const treeChildren = data => {
  const arr = [];
  if (data) {
    for (let i = 1; i < 7; i++) {
      var obj = {};
      obj.title = `${i}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `tree_table_children`;
      obj.render = (h, row) => {
        let num = data[0].ball_json.numSpread.nums[i];
        if (row.row.ball_json.numSpread.nums[i] == 0) {
          return (
            <div class="hot">
              {row.row.numDistribute[i] > 1 ? <span class="badge">{row.row.numDistribute[i]}</span> : ''}
              <span class="table_red">{i}</span>
            </div>
          );
        } else if (num > row.index) {
          return <span class="divide_lost_info lost_info">{row.row.ball_json.numSpread.nums[i]}</span>;
        } else {
          return <span class="lost_info">{row.row.ball_json.numSpread.nums[i]}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};
let dxbChildren = data => {
  var arr = [];
  var shape = ['3:0', '2:1', '1:2', '0:3'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        var num = row.row.ball_json.numSpread.singleDouble[shape[i]];
        var number = data[0].ball_json.numSpread.singleDouble[shape[i]];

        if (num == 0) {
          return <span class={`table_join_red_${i % 2}`}>{shape[i]}</span>;
        } else if (number > row.index) {
          return <span class="divide_lost_info lost_info">{num}</span>;
        } else {
          return <span class="lost_info">{num}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};
let dxChildren = (data, ball) => {
  var arr = [];
  var shape = ['奇', '偶'];
  var str = ['single', 'double'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        var num = row.row.ball_json[ball].ballSingleDouble[str[i]];
        var number = data[0].ball_json[ball].ballSingleDouble[str[i]];

        if (num == 0) {
          return <span class={`table_join_red_${i}`}>{shape[i]}</span>;
        } else if (number > row.index) {
          return <span class="divide_lost_info lost_info">{num}</span>;
        } else {
          return <span class="lost_info">{num}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};

let dxsChildren = (data, type) => {
  var arr = [];
  var shape = ['0', '1', '2', '3'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        var num = row.row.ball_json.numSpread[type][i];
        var number = data[0].ball_json.numSpread[type][i];

        if (num == 0) {
          return <span class="red">{i}</span>;
        } else if (number > row.index) {
          return <span class="divide_lost_info lost_info">{num}</span>;
        } else {
          return <span class="lost_info">{num}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};

const ks = (data, ballindex) => {
  let list = Vue => {
    var ball = ['一', '二', '三', '四', '五'];
    let arr = [
      {
        title: '期号',
        align: 'center',
        key: 'issue_id',
        className: `table_issueId`,
        width: 130
      },
      {
        title: '开奖号码',
        align: 'center',
        width: 80,
        className: `table_issueId`,
        render: (h, { row }) => <span class="issue_result">{row.balls.split(',').join('')}</span>
      },
      {
        title: `开奖号码分布`,
        align: 'center',
        className: `table_issueId`,
        children: treeChildren(data)
      },
      {
        title: `百位`,
        align: 'center',
        className: `table_issueId`,
        children: dxChildren(data, 'ball1')
      },
      {
        title: `十位`,
        align: 'center',
        className: `table_issueId`,
        children: dxChildren(data, 'ball2')
      },
      {
        title: `个位`,
        align: 'center',
        className: `table_issueId`,
        children: dxChildren(data, 'ball3')
      },
      {
        title: `奇偶比走势`,
        align: 'center',
        className: `table_issueId`,
        children: dxbChildren(data)
      },
      {
        title: `奇数个数`,
        align: 'center',
        className: `table_issueId`,
        children: dxsChildren(data, 'single')
      },
      {
        title: `偶数个数`,
        align: 'center',
        className: `table_issueId`,
        children: dxsChildren(data, 'double')
      }
    ];
    return arr;
  };

  return { list };
};

export default ks;



// WEBPACK FOOTER //
// ./src/pages/Trend/Jiouzoushi/columns/ks.js